import { Component, Input, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { SearchSelectFieldComponent } from '@shared/components/search-select-field/search-select-field.component';
import { DespachosService } from '@features/proveedores/services/despachos.service';
import { UserService } from '@core/services/user.service';
import { ToastMessageService } from '@core/services/toast-message.service';

@Component({
  selector: 'app-navbar-search',
  standalone: true,
  imports: [FormsModule, SearchSelectFieldComponent],
  templateUrl: './navbar-search.component.html',
  styleUrl: './navbar-search.component.scss',
})
export class NavbarSearchComponent {
  @Input() options: string[] = [];

  private readonly router = inject(Router);
  private readonly despachosService = inject(DespachosService);
  private readonly userService = inject(UserService);
  private readonly toast = inject(ToastMessageService);

  selectedType = 'Importaciones';
  searchTerm = '';
  isFocused = false;
  isHovered = false;
  readonly isSearching = signal(false);

  onSearch(): void {
    const term = this.searchTerm.trim();
    if (!term || this.isSearching()) return;

    if (this.selectedType === 'Importaciones') {
      this.searchImportacion(term);
    }
  }

  private searchImportacion(nroDespacho: string): void {
    const empresaId = this.userService.companyId();
    if (!empresaId) {
      this.toast.showWarn(
        'Advertencia',
        'Selecciona una empresa antes de buscar',
      );
      return;
    }

    this.isSearching.set(true);

    this.despachosService
      .searchDespachoByNro(empresaId, nroDespacho)
      .subscribe({
        next: (res) => {
          this.isSearching.set(false);
          const despachoId = res.data?.despachoID;
          if (despachoId) {
            this.searchTerm = '';
            this.router.navigate(['/proveedores/despachos', despachoId]);
          } else {
            this.toast.showWarn(
              'Sin resultados',
              `No se encontró la importación "${nroDespacho}"`,
            );
          }
        },
        error: (err: HttpErrorResponse) => {
          this.isSearching.set(false);
          if (err.status === 404) {
            this.toast.showWarn(
              'Sin resultados',
              `No se encontró la importación "${nroDespacho}"`,
            );
          } else {
            this.toast.showError('Error', 'No se pudo realizar la búsqueda');
          }
        },
      });
  }
}
